import { $Q } from './querySelector';
import { createCustomerWithLang } from '../components/create-customer_lang';
import { registerDateInKlaviyo } from '../components/updatecustomer';

/**
 * Validates two passwords checking if they have the same value and then
 * shows an error if required
 *
 * @param {string} buttonSelector - query selector for the button
 * @param {string} formSelector - query selector for the form selector
 */
export const validateMatchingPasswords = (buttonSelector, formSelector) => {
  const $form = $Q(formSelector);
  const $button = $Q(buttonSelector);
  const inputDate = $Q('#RegisterForm-Birthdate');

  if ($form && $button) {
    $form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (
        $Q('input[name="customer[password]"]').value !==
        $Q('input[name="customer[password_confirmation]"]').value
      ) {
        $Q('#RegisterForm-password-confirmation-error').classList.remove(
          'hidden'
        );
      } else if (!inputDate.value && inputDate.required === true) {
        $Q('.Birthdate__error').classList.remove('hidden');
      } else {
        $Q('#RegisterForm-password-confirmation-error').classList.add('hidden');
        $Q('.Birthdate__error').classList.add('hidden');
        createCustomerWithLang().then(() => {
          $form.submit();
        });
      }
    });
  }
};

/**
 * Validate of the input date not have future date.
 */
export const validationFutureDate = () => {
  const inputDate = $Q('#RegisterForm-Birthdate');

  if (inputDate) {
    inputDate.max = new Date().toISOString().split('T')[0];

    inputDate.addEventListener('change', () => {
      if (inputDate.value) {
        if (inputDate.value > inputDate.max) {
          $Q('.Birthdate-future__error').classList.remove('hidden');
          $Q('.submit-button').disabled = true;
        } else {
          $Q('.Birthdate-future__error').classList.add('hidden');
          $Q('.submit-button').disabled = false;
        }
      }
    });
  }
};
